import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL;

const putPlanoTrabalho = async (
  token: string,
  id: number,
  situacao: string,
  observacao?: string
) => {
  const config = {
    headers: {
      Authorization: "Bearer " + token,
    },
  };
  const response = await axios.put(`${API_URL}/planos-de-trabalho/${id}`, { situacao, observacao }, config);
  return response.data;
};
export default putPlanoTrabalho;
